import { UrlSlugsUtil } from '@axiom/utils';
import type {
  Account,
  Candidate,
  Opportunity,
  Taxonomy,
} from '@axiom/validation';
import qs from 'qs';

import { EnvUtil } from './env-util';

const getShareUrl = (
  candidate: Pick<
    Candidate,
    | 'calculatedDisplayName'
    | 'primaryPracticeArea'
    | 'primaryFocusArea'
    | 'publicRefId'
  >,
  taxonomy: Taxonomy
): string =>
  `/browse-talent/${UrlSlugsUtil.generateCandidateSlug(candidate, taxonomy)}`;

const getSharePath = (
  candidate: Pick<
    Candidate,
    | 'calculatedDisplayName'
    | 'primaryPracticeArea'
    | 'primaryFocusArea'
    | 'publicRefId'
  >,
  taxonomy: Taxonomy
): string => {
  const {
    location: { pathname, search },
  } = window;

  const queryParams = {
    page: pathname.split('/').at(-1),
    ...qs.parse(search, { ignoreQueryPrefix: true }),
  };

  const filteredQueryParams = Object.fromEntries(
    Object.entries(queryParams).filter(
      ([_, value]) => value != null && value !== ''
    )
  );

  const queryString = qs.stringify(filteredQueryParams, {
    addQueryPrefix: true,
  });

  return `/browse-talent/${UrlSlugsUtil.generateCandidateSlug(candidate, taxonomy)}${queryString}`;
};

const generateClientProjectsUrl = (account: Pick<Account, 'id'>) =>
  `/account/${account.id}`;

const generateAHQOpportunityURL = (opportunity: Pick<Opportunity, 'id'>) =>
  `${EnvUtil.envoyUrl}/opportunity-detail/${opportunity.id}`;

export const LinkUtil = {
  getShareUrl,
  getSharePath,
  generateClientProjectsUrl,
  generateAHQOpportunityURL,
};
